import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


import MenuStore from "./menuStore"
export default new Vuex.Store({
  modules: {
    MenuStore
  }
})
